/* ============================================================
   MyShilaya — comportements du thème.
   Sans dépendance : rien à charger avant que la page réponde.

   Principe du panier : le panier de Shopify est la seule source de
   vérité. Après chaque modification on redemande le HTML du panier
   à Shopify (Section Rendering API) plutôt que de le reconstruire
   ici — impossible d'afficher un total qui diverge du réel.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  function toast(msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); setTimeout(function () { el.hidden = true; }, 300); }, 2600);
  }

  /* ---------- en-tête ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- menu mobile ---------- */
  var drawer = $('[data-menu-drawer]');
  if (drawer) {
    var openBtn = $('[data-menu-open]');
    var openMenu = function (on) {
      drawer.hidden = !on;
      document.body.classList.toggle('no-scroll', on);
      if (openBtn) openBtn.setAttribute('aria-expanded', String(on));
      if (on) { var f = drawer.querySelector('a, button'); if (f) f.focus(); }
      else if (openBtn) openBtn.focus();
    };
    if (openBtn) openBtn.addEventListener('click', function () { openMenu(true); });
    $$('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { openMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) openMenu(false); });
  }

  /* ---------- panier ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function openCart(on) {
    if (!cartDrawer) return;
    cartDrawer.hidden = !on;
    document.body.classList.toggle('no-scroll', on);
    if (on) {
      var c = cartDrawer.querySelector('.drawer-close');
      if (c) c.focus();
    }
  }

  if (cartDrawer) {
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { openCart(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cartDrawer.hidden) openCart(false); });
    var toggle = $('[data-cart-toggle]');
    if (toggle) toggle.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(function () { openCart(true); }); });
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* On redemande le rendu du panier à Shopify plutôt que de le recalculer. */
  function refreshCart() {
    return fetch(window.routes.cart_url + '?sections=cart-items', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-items'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-empty') ? doc.body.firstElementChild : doc.body;
        $$('[data-cart-contents]').forEach(function (host) { host.innerHTML = doc.body.innerHTML; });
        return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); })
          .then(function (cart) { setCount(cart.item_count); return cart; });
      })
      .catch(function () { /* le panier reste tel quel, aucune donnée inventée */ });
  }

  function changeLine(payload) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }

  /* Délégation : le contenu du panier est remplacé à chaque mise à jour,
     des écouteurs directs seraient perdus au premier changement. */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine({ id: rm.dataset.remove, quantity: 0 }); return; }

    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      var input = q.parentElement.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.qty, 10));
      changeLine({ id: q.dataset.key, quantity: next });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-line input[name="updates[]"]');
    if (!input) return;
    changeLine({ id: input.dataset.key, quantity: Math.max(0, parseInt(input.value, 10) || 0) });
  });

  /* Un formulaire d'ajout au panier, où qu'il soit sur la page. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch(window.routes.cart_add_url, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || window.strings.cartError);
        if (btn) btn.textContent = window.strings.added;
        return refreshCart().then(function () {
          if (cartDrawer) openCart(true);
          else window.location = window.routes.cart_url;
        });
      })
      .catch(function (err) { toast(err.message || window.strings.cartError); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          setTimeout(function () { btn.textContent = label; }, 1400);
        }
      });
  });

  /* ---------- configurateur ---------- */
  $$('[data-buy-configurator]').forEach(function (root) {
    var vId = $('[data-buy-variant]', root);
    var vQty = $('[data-buy-qty]', root);
    var cta = $('.buy-cta', root);
    var base = cta ? cta.dataset.baseLabel : '';

    function sync(radio) {
      if (!radio) return;
      vId.value = radio.value;
      vQty.value = radio.dataset.qty || '1';
      if (cta) cta.textContent = base + ' — ' + (radio.dataset.price || '');
    }

    function select(label) {
      var group = label.closest('.tiers');
      $$('.tier', group).forEach(function (t) { t.dataset.sel = String(t === label); });
      var radio = label.querySelector('input');
      radio.checked = true;
      sync(radio);
    }

    $$('.tier', root).forEach(function (label) {
      label.addEventListener('click', function () { select(label); });
    });

    $$('.fmt-opt', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.fmt-opt', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        $$('.tiers', root).forEach(function (g) { g.hidden = g.dataset.group !== btn.dataset.fmt; });

        var img = $('[data-fmt-img]', root);
        if (img && btn.dataset.img) {
          img.classList.add('is-swapping');
          setTimeout(function () {
            img.src = btn.dataset.img;
            img.removeAttribute('srcset');
            img.alt = btn.dataset.label || '';
            img.classList.remove('is-swapping');
          }, reduce ? 0 : 170);
        }
        var cap = $('[data-fmt-cap]', root);
        if (cap) {
          cap.innerHTML = '';
          var b = document.createElement('b'); b.textContent = btn.dataset.label || '';
          var s = document.createElement('span'); s.textContent = btn.dataset.note || '';
          cap.appendChild(b); cap.appendChild(s);
        }

        /* On resélectionne le premier palier du groupe : laisser une
           sélection invisible active enverrait la mauvaise variante. */
        var group = $('.tiers[data-group="' + btn.dataset.fmt + '"]', root);
        if (group) select($('.tier', group));
      });
    });

    sync($('.tiers:not([hidden]) input:checked', root));
  });

  /* ---------- fiche produit ---------- */
  $$('[data-product-section]').forEach(function (root) {
    var main = $('.pm-main img', root);
    $$('.pm-thumb', root).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.pm-thumb', root).forEach(function (x) { x.classList.toggle('is-active', x === t); });
        if (!main) return;
        main.src = t.dataset.full;
        main.removeAttribute('srcset');
        main.alt = t.dataset.alt || '';
      });
    });

    $$('[data-form-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, parseInt(input.value, 10) + parseInt(b.dataset.formQty, 10));
      });
    });

    var json = $('[data-variants-json]', root);
    var variantInput = $('[data-variant-input]', root);
    if (!json || !variantInput) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    $$('[data-option-position]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var chosen = $$('[data-option-position]', root)
          .filter(function (i) { return i.checked; })
          .sort(function (a, b) { return a.dataset.optionPosition - b.dataset.optionPosition; })
          .map(function (i) { return i.value; });

        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;

        variantInput.value = match.id;
        var price = $('[data-price]', root);
        if (price) {
          var html = '<span class="price' + (match.compare_at_price > match.price ? ' price--sale' : '') + '">' +
            '<span class="price-now">' + money(match.price) + '</span>' +
            (match.compare_at_price > match.price ? '<s class="price-was">' + money(match.compare_at_price) + '</s>' : '') +
            '</span>';
          price.innerHTML = html;
        }
        var add = root.querySelector('[name="add"]');
        if (add) {
          add.disabled = !match.available;
          add.textContent = match.available ? window.strings.addToCart : window.strings.soldOut;
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      });
    });
  });

  /* ---------- slider des enjeux ---------- */
  $$('[data-stakes]').forEach(function (root) {
    var track = $('[data-track]', root);
    var dots = $$('button', $('[data-dots]', root));
    if (!track) return;
    var n = track.children.length, i = 0, held = false, timer = null;
    var delay = parseInt(root.dataset.delay, 10) || 6000;
    var autoplay = root.dataset.autoplay === 'true';

    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, j) { d.setAttribute('aria-selected', String(j === i)); });
    }
    function start() { if (reduce || !autoplay || timer || n < 2) return; timer = setInterval(function () { if (!held && !document.hidden) go(i + 1); }, delay); }
    function nudge(k) { clearInterval(timer); timer = null; go(k); start(); }

    dots.forEach(function (d, j) { d.addEventListener('click', function () { nudge(j); }); });
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { nudge(i - 1); });
    if (next) next.addEventListener('click', function () { nudge(i + 1); });

    root.addEventListener('mouseenter', function () { held = true; });
    root.addEventListener('mouseleave', function () { held = false; });
    root.addEventListener('focusin', function () { held = true; });
    root.addEventListener('focusout', function () { held = false; });

    var x0 = null;
    track.addEventListener('touchstart', function (e) { held = true; x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 !== null) {
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
      }
      x0 = null; held = false;
    }, { passive: true });

    start();
  });

  /* ---------- barres du laboratoire ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    $$('.lab-row').forEach(function (el) { io.observe(el); });
  } else {
    $$('.lab-row').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- mot de passe oublié ---------- */
  var recoverToggle = $('[data-recover-toggle]');
  if (recoverToggle) {
    recoverToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('recover');
      box.classList.add('is-open');
      var f = box.querySelector('input');
      if (f) f.focus();
    });
  }
})();
